import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';

import ActionTypes from './constants';
import { StatesState } from './types';

export const initialState: StatesState = {};

function authReducer(
  state: StatesState = initialState,
  action: ApplicationActions
): StatesState {
  switch (action.type) {
    case ActionTypes.SET_STATES:
      return action.payload;
    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default authReducer;
